<div class="slider">
  
  <div class="slider__slide slider__slide--1">
    <div class="slider__img slider__img--1"></div>
    <div class="slider__text slider__text--1">
      <h1 class="slider__header">Making Your Living More Beautiful.</h1>
      <p>We will help you to make an elegant and luxurious interior designed by professional interior designers.</p>
      <a [routerLink]="['/about']" routerLinkActive="router-link-active"  class="cta">discover</a>
    </div>
  </div>
  
  <div class="slider__slide slider__slide--2">
    <div class="slider__img slider__img--2"></div>
    <div class="slider__text slider__text--2">
      <h1 class="slider__header">Architecture & Construction</h1>
      <p>Our brands serve the full spectrum of the construction industry, including the residential, commercial and industrial markets, and enjoy the custom of professional and private developers, project managers, building contractors, builders, plumbers, electricians, joiners, cabinet-makers.</p>
      <!-- <a href="google.com" class="cta">learn more</a> -->
    </div>
  </div>
  
    <div class="slider__slide slider__slide--3">
    <div class="slider__img slider__img--3"></div>
    <div class="slider__text slider__text--3">
      <h1 class="slider__header">A Creative Business</h1>
      <p>We strive to eliminate all the design hurdles for you and provide you with an all new living & working space by incorporating the design concepts you desire. Our design gurus are equipped to help you determine the products and design that work best for you be it wood, colors and lightings</p>
      <!-- <a href="youtube.com" class="cta">learn more</a> -->
    </div>
  </div>
  
  <div class="slider__slide slider__slide--4">
    <div class="slider__img slider__img--4"></div>
    <div class="slider__text slider__text--4">
      <h1 class="slider__header">What we do.</h1>
      <p>we specialize in custom-made interiors &amp; furniture for high-end residential and business spaces. Checkout some of our work in gallery</p>
      <!-- <a href="tsn.ca" class="cta">discover</a> -->
    </div>
  </div>
  
  <div class="slider__navigation" style="display: none;">
    <div class="slider__count slider__count--top">
      <p class="count count--top count--top-1">01</p>
      <p class="count count--top count--top-2">02</p>
      <p class="count count--top count--top-3">03</p>      
      <p class="count count--top count--top-4">04</p>
    </div>
    
    <div class="slider__bar">
      <div id="sliderBarDynamic" class="slider__bar--dynamic"></div>
      <div class="slider__bar--static"></div>
    </div>
    
     <div class="slider__count slider__count--bottom">
      <p class="count count--bottom count--bottom-1">02</p>
      <p class="count count--bottom count--bottom-2">03</p>
      <p class="count count--bottom count--bottom-3">04</p>      
      <p class="count count--bottom count--bottom-3">01</p>
    </div>
  </div>
  
</div>
<app-testimonials></app-testimonials>
<app-contact-us></app-contact-us>